import { render, staticRenderFns } from "./Kontragent.vue?vue&type=template&id=701b447c&scoped=true"
import script from "./Kontragent.vue?vue&type=script&lang=js"
export * from "./Kontragent.vue?vue&type=script&lang=js"
import style0 from "./Kontragent.vue?vue&type=style&index=0&id=701b447c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701b447c",
  null
  
)

export default component.exports